import post from './POST';

export default { post };